import { useState } from "react";
import SoftBox from "components/SoftBox";
import SlugTabs from "cxfcomponents/SlugTabs";
import Overview from "./Overview";
import Users from "./Users";
import Permissions from "./Permissions";

const tabsData = ["overview", "users", "permissions"];

const RolesTabs = ({ selectedRole, userRoles, roleId }) => {
  const [currentTab, setCurrentTab] = useState("overview");

  const renderTab = () => {
    switch (currentTab) {
      case "overview":
        return <Overview selectedRole={selectedRole} isReadOnlyAccess={false} />;
      case "users":
        return <Users />;
      case "permissions":
        return <Permissions selectedRole={selectedRole} userRoles={userRoles} roleId={roleId} />;
      default:
        return null;
    }
  };

  return (
    <SoftBox pb={3}>
      <SlugTabs tabs={tabsData} value={currentTab} onChange={setCurrentTab} />
      {renderTab()}
    </SoftBox>
  );
};

export default RolesTabs;
